import React from 'react'
import classes from './Copyright.module.css'
const Copyright = () => {
  return (
    <div className={classes.copyright}>
      &#169; UnfilteredMe 2023
    </div>
  )
}

export default Copyright
